import React, { useState } from "react";
import { FC } from "react";
import { BooleanInput, Button, Edit, EditProps, TextInput, Toolbar, useNotify } from "react-admin";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { useHistory } from "react-router-dom";
import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { ReliabilityExclusionPnPutModel } from "./Model/ReliabilityExclusionPnModel";
import { Form } from "react-final-form";
import { Separator } from "../../../../src/Components/Separator";
import { SectionTitle } from "../../../../src/Components/SectionTitle";
import { Update } from "@material-ui/icons";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const ReliabilityExclusionPnEditComponent = props => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const useStyles = makeStyles({
    toolbar: {
      display: "flex",
      justifyContent: "end",
      backgroundColor: "white",
    },
    defaultToolbar: {
      display: "flex",
      justifyContent: "end",
    },
  });

  const classes = useStyles();

  const EditReliabilityExclusionPnButtonClick = e => {
    EditReliabilityExclusionPn(e);
  };

  const EditReliabilityExclusionPn = async e => {
    let editModel: ReliabilityExclusionPnPutModel = new ReliabilityExclusionPnPutModel();

    editModel.Id = props.id;
    editModel.Pn = e.pn;
    editModel.PnDescription = props.record.pnDescription;
    editModel.ExcludeFailOnFit = e.excludeFailOnFit ?? false;
    editModel.ExcludePrematureFailure = e.excludePrematureFailure ?? false;
    editModel.ExcludeRogueUnit = e.excludeRogueUnit ?? false;

    dataProvider
      .putReliabilityExclusionPn(editModel)
      .then(result => {
        notify(`Record updated`, "success", false, true);
        history.push("/reliabilityexclusionpns");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  return (
    <Form
      onSubmit={EditReliabilityExclusionPnButtonClick}
      render={({ handleSubmit }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Edit {...props}>
                <>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Reliability Exclusion PN" />
                  </Grid>
                  <Separator />

                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="pn" label="Pn" fullWidth disabled variant="outlined" />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <BooleanInput label="Exclude Fail on Fit" source="excludeFailOnFit" />
                      <BooleanInput label="Exclude Premature Failure" source="excludePrematureFailure" />
                      <BooleanInput label="Exclude Rogue Unit" source="excludeRogueUnit" />
                    </Grid>
                  </Grid>

                  <Separator />
                  <Toolbar {...props} placeholder="" classes={classes}>
                    <Button
                      label={loading ? "Exclusion PN is updating!" : "Update Exclusion PN"}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                    </Button>
                  </Toolbar>
                </>
              </Edit>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

const ReliabilityExclusionPnEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={"Reliability Exclusion PN Edit"} component="div" hasShow={false}>
      <ReliabilityExclusionPnEditComponent {...props} />
    </Edit>
  );
};

export default ReliabilityExclusionPnEdit;
